<template>
  <div class="moviesdetailApp" :style="'min-height:'+curHeight+'px;'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div style="height:10px"></div>
    <div class="moviesInfo">
      <div class="infoTop">
        <el-image style="width: 100px; height: 120px" :src="setMovies.logo" fit="cover"></el-image>
        <div class="con">
          <h2>{{setMovies.name}}</h2>
          <p>{{setMovies.filmTypes}}</p>
          <p>{{setMovies.playdate}} 上映/{{setMovies.duration}}分钟</p>
          <p>{{setMovies.state}},<font>{{setMovies.type}}</font></p>
        </div>
      </div>
      <div class="infoBottom">
        <h2>简介 <a @click="clamp = (clamp == 3 ? 999 : 3)">{{clamp == 3 ? '展开' : '收起'}}<i class="el-icon-arrow-right"></i></a></h2>
        <p :style="clamp != 3 ? '-webkit-line-clamp: 999;' : '-webkit-line-clamp: 3;'">{{setMovies.content}}</p>
      </div>
    </div>

    <div class="moviesList">
      <h2>演职人员<a @click="show = (show == false ? true : false)">{{show == false ? '查看全部' : '收起'}}<i class="el-icon-arrow-right"></i></a></h2>
      <ul :style="show==false?'height:150px;':''">
        <li>
          <el-image style="width:100%;height: 100px" :src="setMovies.logo" fit="cover"></el-image>
          <p>{{setMovies.director}}</p>
          <p>导演</p>
        </li>
        <li v-for="(item,i) in setMovies.actors">
          <el-image style="width:100%;height: 100px" :src="setMovies.logo" fit="cover"></el-image>
          <p>{{item}}</p>
          <p>演员</p>
        </li>
      </ul>
    </div>

    <!--<div class="moviesList">
      <h2>视频<a @click="show1 = (show1 == false ? true : false)">{{show1 == false ? '查看全部' : '收起'}}<i class="el-icon-arrow-right"></i></a></h2>
      <ul :style="'grid-template-columns: 32% 32% 32%;'+(show1==false ? 'height:120px;' : '')">
        <li v-for="(item,i) in setMovies.videos">
          <el-image style="width:100%;height: 90px" :src="item.cover" fit="cover"></el-image>
          <p>{{item.title}}</p>
          <img class="video" src="~assets/images/video.png" />
        </li>
      </ul>
    </div>-->
    <div class="moviesList">
      <h2>剧照<a @click="show2 = (show2 == false ? true : false)">{{show2 == false ? '查看全部' : '收起'}}<i class="el-icon-arrow-right"></i></a></h2>
      <ul :style="'grid-template-columns: 32% 32% 32%;'+(show2==false ? 'height:120px;' : '')">
        <li v-for="(item,i) in setMovies.trailers">
          <el-image style="width:100%; height: 90px" :src="item" fit="cover"></el-image>
        </li>
      </ul>
    </div>
    <div style="height:80px"></div>
    <div class="moviesBtn" @click="$router.push('cinemalist?id='+setMovies.id)">特惠购票</div>
  </div>
  
</template>

<script>
  import $ from 'jquery' //在需要使用的页面中
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        code:'',
        setMovies:[],
        clamp:3,
        show:false,
        show1:false,
        show2:false
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
      var id = this.$route.query.id
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        if(!code){
          var url = encodeURIComponent('http://user.4008005216.com/main/moviesdetail?id='+id);
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
        }
      }

    },
    mounted() {
      if(localStorage.getItem('userjwt') == null){
        this.login();
      }else{
        this.getMovies()
      }
      this.beforeMount();
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      gpush:function(id){
        window.location.href="http://user.4008005216.com/main/cinemalist?id="+id
      },
      getLocalTime:function(nS) {
        var str = new Date(parseInt(nS)).toLocaleString();
        return str.substr(0, str.length - 8)    
      },
      getMovies:function(){
        var that = this;
        var id = this.$route.query.id
        that.fullscreenLoading = true;
        $.ajax({
          type:'post',
          url:that.$host+'home/movies/movieDetail',
          data:{
            movieId:id,
          },
          dataType:'json',
          success:function(data){
            that.setMovies = data.data;
            document.title = data.data.name;
            that.fullscreenLoading = false;
          }
        })
      },

      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          localStorage.setItem('userjwt', JSON.stringify(res.data));
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      }
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .moviesdetailApp{
    max-width:640px;
    background:#ececec;
    margin:0 auto;
  }
  .moviesdetailApp .moviesInfo{
    background:#fff;
    border-radius:6px;
    width:94%;
    margin:0 auto;
    padding-bottom:15px;
  }
  .moviesdetailApp .infoTop .el-image{
    float:left;
    margin:15px 10px 15px 15px;
  }
  .moviesdetailApp .infoTop .el-image img{
    border-radius:6px;
  }
  .moviesdetailApp .infoTop:after{
    clear: both;
    content: '.';
    display: block;
    width: 0;
    height: 0;
    visibility: hidden;
  }
  .moviesdetailApp .infoTop .con{
    float:left;
    width:calc(100% - 130px);
    margin-top:15px;
  }
  .moviesdetailApp .infoTop .con h2{
    font-size:18px;
  }
  .moviesdetailApp .infoTop .con p{
    font-size:15px;
    color:#666;
    padding-top:8px
  }
  .moviesdetailApp .infoTop .con p font{
    color:#F8A927;
    font-weight:bold;
  }
  .moviesdetailApp .infoBottom{
    padding:0 15px;
  }
  .moviesdetailApp .infoBottom h2{
    font-size:18px;
    padding-bottom:10px
  }
  .moviesdetailApp .infoBottom h2 a{
    float:right;
    font-size:14px;
    font-weight:500;
    color:#666
  }
  .moviesdetailApp .infoBottom p{
    font-size:15px;
    text-align:justify;
    color:#333;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .moviesdetailApp .moviesList{
    background:#fff;
    border-radius:6px;
    width:94%;
    margin:15px auto;
    padding-bottom:15px;
  }
  .moviesdetailApp .moviesList h2{
    font-size:18px;
    padding:15px
  }
  .moviesdetailApp .moviesList h2 a{
    float:right;
    font-size:14px;
    font-weight:500;
    color:#666
  }
  .moviesdetailApp .moviesList ul{
    display: grid;
    grid-template-columns: 18% 18% 18% 18% 18%;/*有几列，每列有多大*/
    grid-gap: 10px;
    padding:0 15px;
    overflow: hidden;
  }
  .moviesdetailApp .moviesList ul li{
    position:relative;
  }
  .moviesdetailApp .moviesList ul li .video{
    position:absolute;
    left:50%;
    transform: translateX(-50%);
    top:25px;
    width:40px
  }
  .moviesdetailApp .moviesList ul li .el-image img{
    border-radius:6px;
  }
  .moviesdetailApp .moviesList ul li p{
    font-size:15px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    -webkit-line-clamp: 1;
    text-align:center;
  }

  .moviesdetailApp .moviesBtn{
    background: linear-gradient(90deg, #FE506A, #FE5CA3);
    width:92%;
    margin:0 auto;
    height:45px;
    border-radius: 45px;
    color:#fff;
    text-align:center;
    line-height:45px;
    position:fixed;
    bottom:32px;
    left:4%
  }
</style>